export const AC_PERSONAL_FOLDER_SCOPE = {
  value1: 4,
  value2: 5,
};

export const AC_SHARED_FOLDER_SCOPE = {
  value1: 2,
  value2: 3,
};

export const AC_GLOBAL_FOLDER_SCOPE = {
  value1: 0,
  value2: 1,
};

export const DEFINITION_EMPTY_SELECTIONBOX_MESSAGE =
  'Start select categories from the left. All the Items will appear in this section.';

export const BASES_DATA_GRID = 'BasesDataGrid';
export const COLUMNS_DATA_GRID = 'ColumnsDataGrid';
export const ROWS_DATA_GRID = 'RowsDataGrid';

export const QUESTION_DELIMETER = '/';
export const ANSWER_DELIMETER = '_';
export const AC_OPERATORS = {
  type: {
    and: { label: 'AND', symbol: 'AND' },
    or: { label: 'OR', symbol: 'OR' },
    andnot: { label: 'AND NOT', symbol: 'AND NOT' },
    ornot: { label: 'OR NOT', symbol: 'OR NOT' },
    xor: { label: 'XOR', symbol: 'XOR' },
    not: { label: 'NOT', symbol: 'NOT' },
  },
  isTop: false,
};

export const AC_ROOT_NODE_ID = '0';
export const AC_NODETYPE_ROOT = 'root';
export const AC_NODETYPE_DATAPOINT = 'dictionary';
export const AC_NODETYPE_DEFINITION = 'definition';
export const AC_NODETYPE_OPERATOR = 'operator';
export const AC_NODETYPE_FUNC = 'func';
export const AC_NODETYPE_BRANGE = 'brange';

// template types for dictionary tree
export const TEMPLATE_TYPE_1 = '1';
export const TEMPLATE_TYPE_1_1 = '1.1';
export const TEMPLATE_TYPE_2 = '2';
export const TEMPLATE_TYPE_3 = '3';
export const TEMPLATE_TYPE_4 = '4';
export const TEMPLATE_TYPE_5 = '5';
export const TEMPLATE_TYPE_6 = '6';
export const TEMPLATE_TYPE_7 = '7';
export const TEMPLATE_TYPE_8 = '8';
export const TEMPLATE_TYPE_9 = '9';

// rectype for autocode dictionary tree
export const AC_RECTYPE_Q = 'Q';
export const AC_RECTYPE_T = 'T';
export const AC_RECTYPE_S = 'S';

// functions for diffrent templates
export const TEMPLATE_1_NODE_CATEGORY = 'Category';
export const TEMPLATE_1_TIME_PERIOD_LABEL_PREFIX = 'users in';
export const AC_FUNCTIONS_TITLE = 'Functions';
export const AC_APPLY_TITLE = 'Apply';
export const AC_COUNT_TITLE = 'Count';
export const AC_DEFINITION_LABEL = 'DefinitionLabel';
export const AC_APPLY_OPTIONS = [
  {
    label: 'to a Group',
    key: 0,
    funcName: 0,
  },
  {
    label: 'to Each Item',
    key: 1,
    funcName: 1,
  },
];
export const AC_COUNT_OPTIONS = [
  {
    label: 'Exactly ',
    key: 0,
    funcName: 'COUNT',
  },
  {
    label: 'A min ',
    key: 1,
    funcName: 'COUNT',
  },
];
export const AC_FUNTIONS_BASED_ON_TEMPLATE = {
  TEMPLATE_1_All: [
    {
      label: 'Volume',
      key: 0,
      funcName: 'VOL',
    },
    {
      label: 'Mean Volume',
      key: 1,
      funcName: 'MEAN VOL',
    },
  ],
    TEMPLATE_1_CATEGORY: [
    {
      label: 'Median Volume',
      key: 0,
      funcName: 'MEDIAN VOL',
    },
    {
      label: 'Mean Volume',
      key: 1,
      funcName: 'MEAN VOL',
    },
    {
      label: 'Volume',
      key: 2,
      funcName: 'VOL'
    }
  ],
  TEMPLATE_2_8: [
    {
      label: 'Total Value',
      key: 0,
      funcName: 'VOL',
    },
    {
      label: 'Mean Value',
      key: 1,
      funcName: 'MEAN',
    },
    {
      label: 'Median Value',
      key: 2,
      funcName: 'MEDIAN',
    },
  ],
  TEMPLATE_4: [
    {
      label: 'Mean',
      key: 0,
      funcName: 'MEAN',
    },
  ],
  TEMPLATE_7 :[
    {
      label: 'Mean Value',
      key: 0,
      funcName: 'MEAN',
    },
  ],
  TEMPLATE_3_5_9: [
    {
      label: 'Mean',
      key: 0,
      funcName: 'MEAN',
    },
    {
      label: 'Median',
      key: 1,
      funcName: 'MEDIAN',
    },
  ],
  DEFINITION_FUNCTIONS: [
    {
      label: 'Mean',
      key: 0,
      funcName: 'MEAN',
    },
    {
      label: 'Median',
      key: 1,
      funcName: 'MEDIAN',
    },
  ],
};

export const AC_TEMPLATE_2_7_8_ARR = ['2', '7', '8'];
export const MRI_SAC_SPRING_FALL_STUDY_STI = 59;
export const AC_PARTS_TO_SHOW = {
  showCat: false,
  showSCats: false,
  showQ: true,
  showA: true,
};

export const AC_1_PLUS_USERS_SUFFIX = '>= 1';
export const AC_SAMPLE_LIMIT = 51;
export const AC_SAMPLE_NCS_LIMIT = 61;
export const MAX_EXPRESSION_LABEL_LIMIT = 1024;
export const MAX_EXPORT_LABEL_LIMIT = 2048;

export const AC_DISABLE_DIFINITION_INFO_MSG = "Definition not available in the current study.";
